import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Button } from "@proda-ai/ui-kit";

import type { CoaSelectState } from "./CoaSelectPrompt";
import { CoaSelectPrompt, coaStateBlocksContinue } from "./CoaSelectPrompt";

export const testIds = {
    main: "CoaGateScreen",
    continueButton: "CoaGateScreen-continue-button",
};

export type CoaGateScreenProps = {
    coaState: CoaSelectState;
    onContinue: () => void;
    onCancel: () => void;
};

/**
 * Standalone CoA step for Operating-Statement-only flows, which have no
 * document-type step to embed the picker in. Shown only when the CoA gate
 * needs the user (see `useCoaAutoFire`) — an error to Retry or a choice to
 * make. Continue stays blocked until a CoA has loaded and been selected.
 */
export const CoaGateScreen = ({
    coaState,
    onContinue,
    onCancel,
}: CoaGateScreenProps) => {
    return (
        <Box data-testid={testIds.main} sx={{ padding: "40px 0" }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: "24px",
                    mx: "2rem",
                }}
            >
                <Typography variant="h1" sx={{ marginBottom: "16px" }}>
                    Create an Extraction
                </Typography>
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                    Choose the chart of accounts to use for this project before
                    uploading the Operating Statement.
                </Typography>
            </Box>
            <CoaSelectPrompt state={coaState} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "16px",
                }}
            >
                <Button
                    pattern="secondary"
                    size="medium"
                    onClick={onCancel}
                    style={{ width: "120px" }}
                >
                    Cancel
                </Button>
                <Button
                    data-testid={testIds.continueButton}
                    pattern="primary"
                    size="medium"
                    disabled={coaStateBlocksContinue(coaState)}
                    onClick={onContinue}
                    style={{ width: "120px" }}
                >
                    Continue
                </Button>
            </Box>
        </Box>
    );
};
